module.exports = __webpack_public_path__ + "static/media/reedMJTokyo1014.1c93edf2.ico";